/**
 * Promo Code Cookie Utilities
 * 
 * Handles storing and retrieving promo/referral codes in cookies so users
 * don't lose their code while navigating the site before signing up.
 */

const PROMO_CODE_COOKIE_NAME = 'ipl_promo_code'
const COOKIE_MAX_AGE_DAYS = 7 // Keep the code for 7 days

/**
 * Set the promo code cookie (client-side)
 */
export function setPromoCodeCookie(code: string): void {
  if (typeof document === 'undefined') return
  
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60 // Convert to seconds
  document.cookie = `${PROMO_CODE_COOKIE_NAME}=${encodeURIComponent(code.toUpperCase())}; path=/; max-age=${maxAge}; SameSite=Lax`
}

/**
 * Get the promo code from cookie (client-side)
 */
export function getPromoCodeCookie(): string | null {
  if (typeof document === 'undefined') return null
  
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=')
    if (name === PROMO_CODE_COOKIE_NAME && value) {
      return decodeURIComponent(value)
    }
  }
  return null
}

/**
 * Clear the promo code cookie (client-side)
 * Call this after the code has been successfully used
 */
export function clearPromoCodeCookie(): void {
  if (typeof document === 'undefined') return
  
  document.cookie = `${PROMO_CODE_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`
}

/**
 * Get the promo code from cookie (server-side)
 * For use in server components or API routes
 */
export function getPromoCodeFromCookies(cookieHeader: string | null): string | null {
  if (!cookieHeader) return null
  
  const cookies = cookieHeader.split(';')
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=')
    if (name === PROMO_CODE_COOKIE_NAME && value) {
      return decodeURIComponent(value)
    }
  }
  return null
}

/**
 * Cookie name export for server-side operations
 */
export const PROMO_COOKIE_NAME = PROMO_CODE_COOKIE_NAME




